// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconApteusde } from "../../../icons/mono/build/icon-apteusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const ApteusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconApteusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  ApteusdeIcon.displayName = 'ApteusdeIcon';
}

export default ApteusdeIcon;